<template>
  <div id="app">
    <!-- 根视窗 -->
    <router-view @loadingHandle="loadingHandle" />
  </div>
</template>

<script>
	import axios from 'axios';
	// import { sensorsdata, setStorageToken, getStorageToken, goAuthLogin, isMain, isLocal } from '@/utils/tools'
	import { getTokenKey, getTppTokenKey, setStorageToken, getStorageToken, goAuthLogin, isMain, isLocal, isWeixin } from '@/utils/tools'
	export default {
		methods: {
			/*
			 *@param: 
			 *@return: 
			 *@Description: 触发加载中
			 *@MethodAuthor:  Zhang Xiao Guang
			 *@Date: 2019-12-31 11:40:51
			*/
			loadingHandle(bool,text){
				if(bool){
					this.$toast.loading({
						duration: 0,
						mask: true,
						message: text
					});
				}else{
					this.$toast.clear();
				}
			},
			getToken(auth, token = null){
				let url = `https://open.xjy.cn/api/career/check_token`;

				axios.post(url, {
					auth: auth,
					token: token
				})
				.then(({data}) => {
					if(data.error == 0) {
							setStorageToken(data.token);
							window.observer.publish('onAuth');
					} else {
							window.observer.publish('login', 'token校验失败', true, true);
					}					
				})
				.catch((err) => {
					console.log('获取token失败');
				});
			},
			init() {
				// http强制跳转
				if(!isLocal() && location.protocol == 'http:'){
					location.href = location.href.replace('http:','https:');
					return;
				}

				// 识别method
				let getParam = function(key) {
					let url = location.href.replace('#/', '/').split('#')[0];
					let value = '';
					let reg = new RegExp('/' + key + '/([^/\\.]+)');
					if(reg.test(url)) {
						value = reg.exec(url)[1];
					}
					reg = new RegExp('[\\?&]' + key + '=([^\\?&]+)');
					if(reg.test(url)) {
						value = reg.exec(url)[1];
					}
					return decodeURIComponent(value);
				};

				// 禁止微信登录标记
				window.localStorage['nologin'] = 0;

				let method = getParam('method');
				switch(method) {
					case 'nologin':
						window.localStorage['nologin'] = 1;
						break;
					case 'relogin':
						if(!getParam('token') && !getParam('auth')) {
							window.localStorage['unionid'] = '';
							let token_key = getTokenKey();
							let tpp_token_key = getTppTokenKey();
							window.localStorage[token_key] = '';
							window.localStorage[tpp_token_key] = '';
							// goAuthLogin('强制重新登录');
							window.observer.publish('login', '强制重新登录', true, true);
							return;
						}
						break;
					case 'clearStorage':
						window.localStorage.clear();
						break;
					default:
						break;
				}

				let auth = getParam('auth');
				let token = getParam('token');
				if(token && token.length != 32) {
					setStorageToken(token);
					window.localStorage['nologin'] = 1;
				} else if (!token) {
					let tpp_token = getStorageToken();
					if(tpp_token && tpp_token.length != 32) {
						window.localStorage['nologin'] = 1;
					}
				}

				if(window.localStorage['nologin'] == 0 || isWeixin()) {					
						this.getToken(auth, token || getStorageToken());
				} else {
						window.observer.publish('onAuth');
				}

				window.observer.subscribe('onAuth', function(){
					  // 去除token
						let url = location.href;
						let new_url = location.href.replace(/token=[a-z0-9]+&?/ig, '').replace(/method=relogin&?/ig, '').replace(/method=clearStorage&?/ig, '').replace(/&$/ig, '').replace(/\?$/ig, '');

						if(url != new_url) {
							// setStorageToken();
							url = new_url.replace(/https?:\/\/.+\//ig, '');

							var u = navigator.userAgent;
							var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
							var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

							if(isAndroid && !!(window.history && history.replaceState)) {
								history.replaceState(url, document.title, url);
							} else {
								return location.href = url;
							}
						}

						window.observer.publish('onRoute');
				});
			},
			initFontSize() {
				let handleFontSize = function() {
			        // 设置网页字体为默认大小
			        WeixinJSBridge.invoke('setFontSizeCallback', {
			          'fontSize': 0
			        });
			        // 重写设置网页字体大小的事件
			        WeixinJSBridge.on('menu:setfont', function() {
						WeixinJSBridge.invoke('setFontSizeCallback', {
							'fontSize': 0
						});
					});
				}

				if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
					handleFontSize();
				} else {
					window.document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
				}
			}
		},
		mounted() {
			let self = this;

			window.observer.subscribe('login', function(reason){
				goAuthLogin(reason, null, 'snsapi_userinfo');
			});
			// window.observer.subscribe('sensorsdata_ready', function(){
			// 	// window.observer.subscribe('onGotUnionid', function(unionid){
			// 	// 	sensors.login(unionid);
			// 	// 	sensors.quick('autoTrack');
			// 	// });
			// 	// if(window.localStorage['unionid']) {
			// 	// 	window.observer.publish('onGotUnionid', window.localStorage['unionid']);
			// 	// }
			// 	window.observer.subscribe('onGotToken', function(token){
			// 		self.getUnionid(token);
			// 		self.mockLogin(token);
			// 	});
			// });
			// sensorsdata(function(){
			// 	// sensors.quick('isReady',function(){
			// 		window.observer.publish('sensorsdata_ready', 'ok', true, true);
			// 	// });
			// });
			// setTimeout(function(){
			// 	window.observer.publish('sensorsdata_ready', 'timeout', true, true);
			// }, 1000);

			// setTimeout(function(){
			// 	window.observer.publish('sensorsdata_ready', 'ok', true, true);
			// }, 0);

			self.init();
			self.initFontSize();

			//DEBUG
			// window.vm = this;
		}
	}
</script>

<style lang="scss">
#app {
  font-family: "Helvetica Neue", Helvetica, Arial, "PingFang SC", "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", "WenQuanYi Micro Hei", sans-serif;
}
</style>